import '../index.css';

import { useState } from 'react';

import sideMenuArrow from '../../../../assets/icons/SideMenu/side-menu-arrow.png';
// import SideMenuToggleBtnIcon from '../../../../assets/icons/side-menu-toggle-btn-icon.svg';
import logo from '../../../../assets/logo/abcc_wallet_logo_side_menu_collapsed.png';
import { useTranslation } from '../../../../hooks';

interface ToggleButtonProps {
  isCollapse: boolean;
  onCollapseClick?: () => void;
}

const ToggleButton = (props: ToggleButtonProps) => {
  const { onCollapseClick, isCollapse } = props;

  // boolean for animation usage
  const [isClicked, setIsClicked] = useState(false);

  const { t } = useTranslation('menu');

  const arrowImgSrc = sideMenuArrow;
  const text = isCollapse ? `${t('toggleBtnExpand')}` : `${t('toggleBtnCollapse')}`;

  const onClick = () => {
    setIsClicked(true);
    onCollapseClick && onCollapseClick();
  };

  const onAnimationEnd = () => {
    setIsClicked(false);
  };

  return (
    <>
      {isCollapse && <div className={`toggle-btn-overlay`}></div>}
      <div
        className={`toggle-btn 
          ${isCollapse ? 'expand' : 'collapse'} 
          ${isClicked ? 'fade-in-out' : ''}`}
        onClick={onClick}
        onAnimationEnd={onAnimationEnd}
      >
        <div className="text-container">
          <img
            src={arrowImgSrc}
            alt="arrow"
            className="arrow"
            style={{
              width: '15px',
              transform: isCollapse ? 'rotate(180deg)' : undefined,
              transition: 'transform 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            }}
          />
          {/* {text} */}
        </div>
        {isCollapse && <img src={logo} alt="toggle-logo" className="toggle-btn-icon" />}
      </div>
    </>
  );
};

export default ToggleButton;
